export const filterItemsByKeyword = (items, keyword) =>
  items.filter(
    (item) =>
      item.alwaysShow ||
      item.value.toLowerCase().includes(keyword.toLowerCase())
  );
